import { NodeViewContent, NodeViewProps, NodeViewWrapper } from '@tiptap/react';
import { FunctionComponent } from 'react';
import { CloseWrapper } from '../../helpers';

import classes from './CalloutNodeView.module.scss';

export const CalloutNodeView: FunctionComponent<NodeViewProps> = ({ editor, node, getPos }) => {
  return (
    <NodeViewWrapper as={'div'}>
      <CloseWrapper editor={editor} node={node} getPos={getPos}>
        <NodeViewContent as={'div'} className={classes['callout']} />
      </CloseWrapper>
    </NodeViewWrapper>
  );
};
